import { CurrentPoint } from 'ff/debrief/models';
import { KTS_TO_MPH } from 'ff/debrief/utils';

/**
 * Convert airspeed properties (IAS, TAS, GS) from knots to the target unit.
 *
 * Source data defaults to kts. If the speedUnit is 'mph', convert the three
 * airspeed properties (indicatedAirSpeed, trueAirSpeed, groundSpeed).
 *
 * @param point - Flight data point with airspeeds in knots
 * @param targetUnit - Target unit for display ('kts' or 'mph')
 * @returns New point with airspeeds converted to target unit
 */
export function convertAirspeeds(
    point: CurrentPoint,
    targetUnit: string
): CurrentPoint {
    if (targetUnit === 'kts') {
        return point;
    }

    return {
        ...point,
        indicatedAirSpeed: point.indicatedAirSpeed * KTS_TO_MPH,
        trueAirSpeed: point.trueAirSpeed * KTS_TO_MPH,
        groundSpeed: point.groundSpeed * KTS_TO_MPH,
    };
}
